const dev = {
  env: 'dev',
  connect: {
    TOPIC: 'dev-new-invoice-upload',
    PILEUS_BUCKET: 'dev-invoice-update',
    AWS_ACCOUNT: '932213950603',
  },
};

const integration = {
  env: 'integration',
  connect: {
    TOPIC: 'integration-new-invoice-upload',
    PILEUS_BUCKET: 'integration-invoice-update',
    AWS_ACCOUNT: '908027420124',
  },
};

const prod = {
  env: 'prod',
  connect: {
    TOPIC: 'prod-new-invoice-upload',
    PILEUS_BUCKET: 'prod-invoice-update',
    AWS_ACCOUNT: '932213950603',
  },
};

const getConfig = () => {
  switch (import.meta.env.VITE_APP_STAGE) {
    case 'prod':
      return prod;
    case 'integration':
      return integration;
    default:
      return dev;
  }
};

const config = getConfig();

export default {
  // common config values here
  ...config,
};
